/**
 * Interaction mode of the image/video viewer, i.e. what a pointer gesture on
 * the canvas is currently meant to do to the ROIs.
 */
export enum ViewerMode {
  idle = 'idle',
  drawing = 'drawing',
  selecting = 'selecting',
  removing = 'removing',
  free = 'free',
}
